const scriptRegEx = /<script\b[^>]*>([\s\S]*?)<\/script>/gm;

function adjustScriptsInText(text, script) {
    let newText = text;

    for (let i = 0; i < script.length; i += 1) {
        let type = '';
        if (script[i].includes('podigee')) {
            type = 'podigee';
        } else if (script[i].includes('lpcontent')) {
            type = 'lpcontent';
        } else {
            // eslint-disable-next-line no-continue
            continue;
        }

        newText = text.replace(scriptRegEx, `<div class="scriptPlaceHolder-${type}"></div>`);
    }
    return newText;
}

function formatAndAddPodigeeScript(script, i) {
    const regExpSrc = /src\s*=\s*"(.+?)"/;
    const regExpClassName = /class\s*=\s*"(.+?)"/;
    const regExpDataConf = /data-configuration\s*=\s*"(.+?)"/;

    const src = regExpSrc.exec(script);
    const className = regExpClassName.exec(script);
    const dataConf = regExpDataConf.exec(script);

    const newScript = document.createElement('script');

    newScript.setAttribute('type', 'text/javascript');
    newScript.setAttribute('language', 'javascript');

    if (src) {
        newScript.setAttribute('src', src[1]);
    }

    if (className) {
        newScript.setAttribute('class', className[1]);
    }

    if (dataConf) {
        newScript.setAttribute('data-configuration', dataConf[1]);
    }

    const targetClass = document.getElementsByClassName('scriptPlaceHolder-podigee');

    setTimeout(() => {
        targetClass[i].insertAdjacentElement('afterbegin', newScript);
    }, 100);
}

function formatAndAddLPContentScript(script, i) {
    const regExpSrc = /src\s*=\s*"(.+?)"/;
    const src = regExpSrc.exec(script);

    const newScript = document.createElement('script');

    if (src) {
        newScript.setAttribute('src', src[1]);
    }
    newScript.setAttribute('async', '');
    newScript.setAttribute('defer', '');

    const targetClass = document.getElementsByClassName('scriptPlaceHolder-lpcontent');

    setTimeout(() => {
        targetClass[i].insertAdjacentElement('afterbegin', newScript);
    }, 100);
}

function formatAndAddScripts(script) {
    for (let i = 0; i < script.length; i += 1) {
        if (script[i].includes('podigee')) {
            formatAndAddPodigeeScript(script[i], i);
        } else if (script[i].includes('lpcontent')) {
            formatAndAddLPContentScript(script[i], i);
        }
    }
}

/**
 * evaluates texts for scripts and formats and adds them to the page
 * @param text
 * @returns {*}
 */
export function evaluateTextForScripts(text) {
    const script = text.match(scriptRegEx);
    if (!script) {
        return text;
    }

    // this can be calculated asynchronously
    setTimeout(() => formatAndAddScripts(script), 20);
    return adjustScriptsInText(text, script);
}

export default {
    evaluateTextForScripts,
};
